const MINUTES_IN_HOUR = 60
const MINUTES_IN_DAY = MINUTES_IN_HOUR * 24
const MINUTES_IN_WEEK = MINUTES_IN_DAY * 7

const DURATION_UNITS = [
  { label: 'week', minutes: MINUTES_IN_WEEK },
  { label: 'day', minutes: MINUTES_IN_DAY },
  { label: 'hour', minutes: MINUTES_IN_HOUR },
  { label: 'minute', minutes: 1 },
]

const formatDurationPart = (value, label) => `${value} ${label}${value === 1 ? '' : 's'}`

export const normalizeDeadlineMinutes = (value) => {
  const normalizedMinutes = Number(value)

  if (!Number.isInteger(normalizedMinutes) || normalizedMinutes < 1) {
    return null
  }

  return normalizedMinutes
}

export const formatTaskTemplateDeadlineDuration = (value) => {
  const normalizedMinutes = normalizeDeadlineMinutes(value)

  if (normalizedMinutes === null) {
    return null
  }

  let remainingMinutes = normalizedMinutes
  const durationParts = []

  for (const unit of DURATION_UNITS) {
    const unitValue = Math.floor(remainingMinutes / unit.minutes)

    if (unitValue < 1) {
      continue
    }

    durationParts.push(formatDurationPart(unitValue, unit.label))
    remainingMinutes -= unitValue * unit.minutes
  }

  return durationParts.join(' ')
}

export const formatTaskTemplateDeadlineLabel = (value, prefix = 'After') => {
  const formattedDuration = formatTaskTemplateDeadlineDuration(value)

  if (formattedDuration === null) {
    return null
  }

  return `${prefix} ${formattedDuration}`
}
